import { PortraitSharp } from '@material-ui/icons';
import React from 'react';

// tslint:disable: max-line-length
interface Props {
  width?: number;
  className?: string;
  title?: string;
  color?: string;
}
export default function Important(props: Props) {
  return (
    <svg
      className={props.className}
      width={props.width ? props.width + 'px' : '21px'}
      height="20px"
      viewBox="0 0 27 26"
      version="1.1"
    >
      <title>Important</title>
      <g id="-Styleguides" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="BOARD-3---Icônes"
          transform="translate(-310.000000, -185.000000)"
          fill={props.color ? props.color : '#ff3f33'}
        >
          <g id="Pictogrammes" transform="translate(305.000000, 181.000000)">
            <g id="1---Important" transform="translate(5.000000, 0.000000)">
              <path
                d="M13.4751517,4 L13.7037488,4.00537197 C15.3712401,4.08395209 16.8364213,5.02002606 17.6517237,6.51054384 L17.6517237,6.51054384 L26.4026366,22.8146504 C27.2265861,24.3440622 27.1981741,26.1331853 26.3174004,27.6337403 C25.4650387,29.1054384 23.9307878,30 22.2260645,30 L22.2260645,30 L4.75265093,30 C3.04792765,30 1.5136767,29.1054384 0.661315064,27.6337403 C-0.191046574,26.1331853 -0.219458629,24.3440622 0.576078901,22.8435072 L0.576078901,22.8435072 L9.29857967,6.53940067 C10.1509413,4.95227525 11.7136043,4 13.4751517,4 L13.4751517,4 Z M13.4751517,6.22197558 L13.2888612,6.22848226 C12.4256735,6.28905167 11.6548861,6.77025527 11.2305994,7.57824639 L11.2305994,7.57824639 L2.53651067,23.9112098 C2.11032985,24.7192009 2.1387419,25.6714761 2.59333478,26.4794673 C3.04792765,27.2874584 3.87187724,27.7491676 4.78106298,27.7491676 L4.78106298,27.7491676 L22.2260645,27.7491676 C23.1636623,27.7491676 23.9876119,27.2874584 24.4422048,26.4794673 C24.8967977,25.6714761 24.9252097,24.7192009 24.4706168,23.8823529 L24.4706168,23.8823529 L15.719704,7.57824639 C15.2651111,6.74139845 14.4411616,6.22197558 13.4751517,6.22197558 L13.4751517,6.22197558 Z M13.4751517,21.6603774 C14.4695736,21.6603774 15.2366991,22.4395117 15.2366991,23.4495006 C15.2366991,24.4306326 14.4411616,25.2386238 13.4751517,25.2386238 C12.5091418,25.2386238 11.7136043,24.4306326 11.7136043,23.4495006 C11.7136043,22.4683685 12.5091418,21.6603774 13.4751517,21.6603774 Z M13.4751517,10.9833518 C14.4127495,10.9833518 15.208287,11.7624861 15.208287,12.7436182 L15.208287,12.7436182 L15.208287,12.9744728 L14.3559254,20.3041065 C14.1002169,20.2463929 13.7876843,20.1886792 13.5035638,20.1886792 C13.2194432,20.1886792 12.9353227,20.2175361 12.6796142,20.3041065 L12.6796142,20.3041065 L11.7420164,12.9744728 C11.6851923,12.4839068 11.8272525,11.9933407 12.1681972,11.5893452 C12.5091418,11.2142064 12.9921468,10.9833518 13.4751517,10.9833518 Z"
                id="Combined-Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
